import React, {useEffect, useState, useCallback} from 'react';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import {SMCPaths} from '../../conf/Routes';
import SMCLabel from '../../components/Simple/SMCLabel';

function IdleModal({
    isOpen,
    onRequestClose,
}) {

    const [logoutTimer, setLogoutTimer] = useState(null);

    const doLogout = useCallback(() => {
        window.location.href = SMCPaths.logout;
    }, []);

    useEffect(() => {
        let logoutTimeoutCodeRef;
        // On open
        if (isOpen) {
            setLogoutTimer(30);
            logoutTimeoutCodeRef = setInterval(() => {
                setLogoutTimer(timer => timer?timer-1:timer);
                
            }, 1000*1);
        }
        // On close
        else if (logoutTimeoutCodeRef) {
            clearTimeout(logoutTimeoutCodeRef);
            logoutTimeoutCodeRef = null;
            setLogoutTimer(null);
        }

        return () => {
            clearTimeout(logoutTimeoutCodeRef);
        }
        
    }, [isOpen]);

    useEffect(() => {
        if (logoutTimer === 0) {
            doLogout();
        }
    }, [logoutTimer, doLogout]);

    return (
        <SMCModal
            isOpen={isOpen}
            height={205}
            width={400}
            onRequestClose={onRequestClose}
            title="Idle"
        >
            <SMCModalBody style={{ paddingTop: '5px' }}>
                <SMCLabel>For security reasons, you will be logged out in {logoutTimer} seconds.</SMCLabel>
                <SMCLabel>Confirm activity to stay logged in.</SMCLabel>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={doLogout}>Log out</SMCButton>
                <SMCButton onClick={onRequestClose}>Stay logged in</SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default IdleModal;